import React from 'react'
import ResponsiveImage from 'components/util/ResponsiveImage'
import PropTypes from 'prop-types'
import styles from './_featuresLanding.css'
import AppLinks from '../shared/AppLinks'

import mobileScreen from 'images/landing/china/features/mobile.png'
import desktopScreen from 'images/landing/china/features/desktop.png'

function Feature (props) {
  const { title, description } = props
  return (
    <div className={styles.feature}>
      <h3 className={styles.featureTitle}>{title}</h3>
      <p className={styles.featureDescription}>{description}</p>
    </div>
  )
}

Feature.propTypes = {
  title: PropTypes.object,
  description: PropTypes.object,
}

function Features () {
  const transparentPixel = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
  return (
    <div className={styles.features}>
      <div className={styles.content}>
        <Feature
          title='一切皆可追踪'
          description='使用手机或喜爱的设备（如 Apple Watch），记录任何类型的锻炼。'
        />
        <Feature
          title='结伴而行'
          description='与其他跑步者彼此支持、互勉互进，同时创建挑战，供朋友们与自己切磋一番。'
        />
        <Feature
          title='更精明地训练'
          description='在应用或网页上分析数据，接着利用我们的适用锻炼计划，征服5公里或马拉松挑战。'
        />
        <div className={`${styles.screen} ${styles.mobileOnly}`}>
          <ResponsiveImage src={mobileScreen} large={transparentPixel} />
        </div>
        <AppLinks />
      </div>
      <div className={styles.screen}>
        <ResponsiveImage large={desktopScreen} />
      </div>
    </div>
  )
}

export default Features
